declare const KUSTOMER_ENV: string

export interface KustomerConfig {
  apiKey: string
  brandId: string
  assistantId: string
  scheduleId: string
  lang?: string
}

export interface AppConfig extends KustomerConfig {
  liveHelpText: string
}

export function getConfigForLocale(locale: string): AppConfig | undefined {
  const kustomerConfig = getConfig();

  if (!kustomerConfig.hasOwnProperty(locale))
    return undefined

  const config = kustomerConfig[locale]
  config.lang = locale.split('-')[0]
  return config
}

function getConfig(): { [key: string]: AppConfig } {
  const config: { [key: string]: AppConfig } = {}
  return config
}

